import React from "react";
import ReactDOM from "react-dom/client";
import { createPortal } from "react-dom";
import "./styles/scss/Modal.scss";
import warningIcon from "./styles/scss/img/common/warning-icon.png";
import succIcon from "./styles/scss/img/common/succ-icon.png";

const createContainer = () => {
	const div = document.createElement("div");
	div.classList.add("popup", `popup-${+new Date()}`, "popup-show");
	document.body.appendChild(div);

	return div;
};

const insertDom = (data) => {
	const { className, content, onClose, hideClose } = data;

	const div = createContainer();

	const root = ReactDOM.createRoot(div);

	root.render(
		<div className={className}>
			<button
				type="button"
				className="popup-close"
				onClick={() => {
					onClose();
				}}
				style={{ display: hideClose ? "none" : "block" }}
			></button>
			{content}
		</div>
	);

	return {
		root,
		div,
	};
};

class App extends React.Component {
	constructor(props) {
		super(props);
		this.container = null;
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.visible) {
			return true;
		} else {
			this.container && this.container.classList.remove("popup-show");
			return false;
		}
	}

	componentWillUnmount() {
		this.container && document.body.removeChild(this.container);
	}

	render() {
		const { visible, className, children, hideClose } = this.props;

		if (visible) {
			if (this.container) {
				this.container.classList.add("popup-show");
			} else {
				this.container = createContainer();
			}
		}

		return (
			visible &&
			this.container &&
			createPortal(
				<div className={className}>
					<button
						type="button"
						className="popup-close"
						onClick={() => {
							this.props.onClose?.();
						}}
						style={{ display: hideClose ? "none" : "block" }}
					></button>
					{children}
				</div>,
				this.container
			)
		);
	}
}

App.tips = function (data) {
	//动态方法
	const {
		title,
		icon,
		contentHead,
		contentBody,
		okBtn,
		okClassName = "",
		okText = "确定",
		cancelBtn,
		cancelClassName = "",
		cancelText = "取消",
	} = data;

	let root = null;
	let div = null;

	const instance = insertDom({
		...data,
		className: "popup-sys",
		content: (
			<div className="popup-content">
				{title && <span>{title}</span>}
				<div className="content">
					{icon && (
						<img
							src={
								icon === "warning"
									? warningIcon
									: icon === "succ"
									? succIcon
									: warningIcon
							}
							alt="icon"
						/>
					)}
					<div>
						<div className="head" style={{ marginTop: contentBody ? 0 : 15 }}>
							{contentHead}
						</div>
						<div className="body" style={{ marginTop: contentHead ? 10 : 15 }}>
							{contentBody}
						</div>
					</div>
				</div>
				<div className="btn-group">
					{cancelBtn !== null && (
						<button
							type="button"
							className={cancelClassName}
							onClick={onCancel}
						>
							{cancelText}
						</button>
					)}

					{okBtn !== null && (
						<button type="button" className={okClassName} onClick={onOk}>
							{okText}
						</button>
					)}
				</div>
			</div>
		),
		onClose,
	});

	root = instance.root;
	div = instance.div;

	function close() {
		root.unmount();
		document.body.removeChild(div);
	}

	function onClose() {
		close();
		data.onClose?.();
	}

	function onOk() {
		data.onOk?.(close);
	}

	function onCancel() {
		data.onCancel?.(close);
	}
};

export default App;
